module.exports = {
  common: {
    edit: "編輯",
    apply: "申請",
    activate: "激活",
    delete: "刪除",
    cancel: "取消",
    success: "成功",
    fail: "失敗",
    save: "保存",
    ensure: "確定",
    submit: "提交",
    remark: "備註",
    detail: "查看",
    action: "操作",
    open: "開啟",
    close: "關閉",
    back: "返回",
    export: "導出",
    modify: "修改",
    layout: "退出登錄",
    noListData: "列表無數據",
    more: "詳情",
    add: "新增",
    delSuccess: "刪除成功！",
    addFailure: "添加失敗！",
    logOut: "註銷",
    delAllInfo: "是否繼續執行刪除操作？",
    saveTip: "您還未保存頁面內容，是否繼續離開?",
    tip: "提示",
    yes: "是",
    no: "否",
    delTip: "勾選激活",
    batchDelete: "批量刪除",
    search: "查詢",
    permission: "暫無權限，請返回",
    reset: "重置",
  },
  breadcrumbItem: {
    home: "名字列表配置",
    data: "設備通用配置打包",
    alarm: "防區配置",
    house: "戶型圖配置",
    name: "名字列表配置",
  },
  errorRes: {
    res82: "系統繁忙，請稍後再試",
  },
  openConfig: {
    title: "設備通用配置",
    version: "協議版本",
    versionTip: "請選擇協議版本",
    checkVersion: "協議版本不得為空，請重新選擇",
    signType: "簽名算法類型",
    checkSignType: "簽名算法類型不得為空，請重新選擇",
    fileLabel: "選擇文件",
    addFile: "添加文件",
    fileName: "文件名",
    zipType: "壓縮文件方式",
    noZip: "不壓縮",
    noFile: "暫未添加文件",
    checkFile: "配置文件為空，請添加文件",
    name: "名字",
    nameTip: "輸入長度為1-10位",
    checkName: "名字不得為空，請重新輸入",
    checkName1: "名字輸入有誤，請重新輸入",
    room: "設備編號",
    roomTip: '輸入長度為1-24位，通過"-"區分層級',
    checkRoom: "設備編號不得為空，請重新輸入",
    checkRoom1: "設備編號輸入有誤，請重新輸入",
    pic: "圖片",
    add: "添加",
    reset: "重置",
    picTip: "圖片文件最大上傳3m",
    checkPic: "圖片文件不得為空，請重新選擇",
    imgRegTip: "只允許上傳jpg、jpeg、png格式的文件",
    excRegTip: "只允許上傳xls、xlsx格式的文件",
    zipRegTip: "只允許上傳zip格式的文件",
    produce: "生成配置文件",
    confType: "配置類型",
    pack: "打包",
    batchAdd: "批量添加",
    singleAdd: "單個添加",
    modelBatch: "下載批量導入模板",
    uploadInfo: "上傳基礎信息Excel",
    uploadPic: "上傳圖片包Zip",
    addName: "添加單條數據",
    sameTip: "序號：",
    sameTip1: "的設備編號重複",
    modelError: "上傳的基礎信息文件內容不正確，請對照模板修改文件",
    noPic: "列表中有未添加圖片的數據，需補全圖片後再生成配置文件",
    picBtnTip: "請先上傳基礎信息文件",
    devType: "設備類型",
    devTypeTip: "請選擇設備類型",
    checkDevType: "設備類型不得為空，請重新選擇",
    indexName: "序號",
    IS: "室內機",
    GU: "管理機",
    OS1: "門口機",
    OS2: "圍牆機",
    OS3: "小門口機",
    nameListTip:
      "上傳的基礎數據中，存在名稱字段不完整的數據，其余正確數據已導入",
    numListTip:
      "上傳的基礎數據中，存在設備編號字段不完整的數據，其余正確數據已導入",
  },
  alarm: {
    ad: "AD防區",
    io: "IO防區",
    alarmPlus: "防區擴展",
    num: "編號",
    open: "開",
    close: "關",
    machine: "探測器類型",
    sendType: "觸發類型",
    mode: "模式",
    mType1: "紅外",
    mType2: "門磁",
    mType3: "窗磁",
    mType4: "瓦斯",
    mType5: "煙霧",
    mType6: "門鈴",
    mType7: "手報按鈕",
    mType8: "紅外門磁",
    mType9: "手報門磁",
    mType10: "振動",
    mType11: "氣壓",
    mType12: "其他",
    send1: "24小時即報",
    send2: "延時報警",
    send3: "傳遞延時",
    send4: "立即報警",
    send5: "交叉報警",
    mode1: "常開",
    mode2: "常關",
    presence: "在家",
    leaving: "離家",
    timeSet: "布防相關時間設置",
    delayTime: "布防生效延時（秒）",
    startDelay: "報警觸發延時（秒）",
    startUtil: "報警持續時間（分）",
    associated: "關聯防區",
  },
  house: {
    dev: "設備",
    scene: "場景",
    vine: "傳感器",
    single: "獨立控制場景",
    light: "燈光",
    air: "空調",
    heat: "地暖",
    fresh: "新風",
    switch: "開關插座",
    curtain: "窗簾",
    water: "熱水器",
    bgm: "背景音樂",
    cust: "自定義設備",
    slight: "燈光",
    sAir: "空調",
    sHeat: "地暖",
    sFresh: "新風",
    sSwitch: "開關插座",
    sCurtain: "窗簾",
    sWater: "熱水器",
    sBgm: "背景音樂",
    sCust: "自定義設備",
    IndependentControl: "獨立控制場景",
    scene1: "場景1",
    scene2: "場景2",
    scene3: "場景3",
    scene4: "場景4",
    scene5: "場景5",
    scene6: "場景6",
    scene7: "場景7",
    scene8: "場景8",
    temp1: "溫度",
    temp2: "濕度",
    temp3: "甲烷",
    temp4: "有機氣體",
    picTip: "暫無戶型圖",
    upload: "上傳戶型圖",
    imgSize: "單張戶型圖的圖片大小不得超過10M",
    imgName: "上傳的戶型圖文件名稱不得出現中文，請重新選擇",
    imgLength: "戶型圖上傳添加總數不得超過8張，已自動選擇文件夾中的前8張圖片",
    imgCheckTip: "戶型圖不匹配，請重新上傳",
    room1: "戶型圖1",
    room2: "戶型圖2",
    room3: "戶型圖3",
    room4: "戶型圖4",
    room5: "戶型圖5",
    room6: "戶型圖6",
    room7: "戶型圖7",
    room8: "戶型圖8",
    download: "導出",
    input: "導入配置",
    title: "設備參數表",
    name: "名稱",
    location: "位置",
    start: "啟動",
    see: "可見",
    noSee: "不可見",
    belong: "所屬",
    bgIcon: "藍灰圖標",
    vineTip: "請選擇戶型圖後，再進行設置溫控屬性",
    sceneTip: "請選擇戶型圖後，再進行設置場景屬性",
    dragTip: "請選擇戶型圖後，再進行拖動操作",
    editTip: "編輯成功",
    addTip: "上傳時，需要一次性選中所有戶型圖",
    editError: "請指定編輯內容後，再進行編輯",
    delError: "請指定刪除內容後，再進行刪除",
    delTip: "刪除成功",
    imgAddTip: "戶型圖上傳添加總數已達8張，無法再添加",
    houseTitle: "戶型圖切換：",
    delHouseTip: "此操作將刪除該張戶型圖以及配置內容，是否繼續？",
    sendTip: "導入配置內容進行再次修改，可上傳xml 文件",
    checkType: "上傳的文件格式錯誤，請檢查文件內容後重新上傳",
    importTip: "導入配置文件",
    importTip1: "導入相應戶型圖",
    upLoadBtn: "上傳",
    picContent: "戶型圖上傳順序，需要與配置文件中戶型圖排序一致",
    successFile: "配置文件上傳成功",
    vineTipCheck: "名稱不得為空，請確認輸入",
    picNumMax:
      "請確認導入圖片的數量，當前導入圖片數量大於配置文件中戶型圖數量，請重新選擇",
    picNumMin:
      "請確認導入圖片的數量，當前導入圖片數量小於配置文件中戶型圖數量，請重新選擇",
    maxSizeTip:
      "該類型添加數量或添加總數超出限制，若需添加，請先整理已添加的設備或場景",
    devNameTip: "請輸入名稱",
    chromeTip: "建議使用Chrome瀏覽器",
    downTip: "點擊跳轉下載鏈接",
    imgRegTip: "只允許上傳jpg、jpeg格式的文件",
    threeTitle: "三恒系統",
    mainControl: "主控",
    sedControl: "分控",
    controlBtn: "配置",
    configEdit: "三恒系統配置詳情",
    moveTip: "圖標請拖動至戶型圖區域內，請重新拖動",
    repeatNameTip: "不能上傳相同名稱的戶型圖，請重新選擇",
    space: "（預留）",
  },
  updateConfig: {
    tip0: "當設置24小時即報時，設置開關為開",
    tip1: "當設置24小時即報時，應設置開關為開",
    tip2: "當設置立即報警時，應設置開關為開",
    tip3: "延時報警關閉時，傳遞延時需設置為關閉",
    tip4: "已設置交叉報警，需要關聯操作",
    tip5: "請先開啟延時報警",
    tip6: "當設置立即報警時，設置開關為開",
  },
  audio: {
    title: "語音提示打包工具",
    lock: "開鎖提示音",
    call: "呼叫提示音",
    speak: "通話提示音",
    busy: "忙提示音",
    tip1: "點擊上傳.wav格式文件",
    tip2: "文件大小不超過1M",
    tip3: "請上傳.wav格式文件",
    tip4: "請上傳全部文件",
    add: "生成文件",
  },
  threeProject: {
    hotWater: "熱水系統",
    cho: "甲醛",
    config: "配置",
    unconfig: "不配置",
  },
  elevator: {
    title: "梯控配置產生",
    label: "上傳梯控配置表",
    uploadTip: "點擊或拖拽檔案至此處上傳",
    upload: "上傳",
    download: "下載範本",
    downloadTip: "點擊下載梯控配置表範本",
    error1: "【實體樓層】有誤，請檢查配置檔案後重新匯入",
    error2: "【顯示樓層】有誤，請檢查配置檔案後重新匯入",
    error3: "【梯控閘道地址】有誤，請檢查配置檔案後重新匯入",
    error4: "【梯號顯示】有誤，請檢查配置檔案後重新匯入",
    error5: "【裝置IP】有誤，請檢查配置檔案後重新匯入",
    error6: "【梯控閘道】數量超限，請檢查配置檔案後重新匯入",
    generate: "梯控配置表範本",
    fileLabel: "梯控配置檔案：",
    tip: "請把配置檔案放於 Pc 工具中的【資源升級】匯入至裝置",
    downloadfile: "下載",
    fileName: "梯控配置檔案.xlsx",
    formatError: "上傳的檔案格式錯誤，請檢查檔案內容後重新上傳",
  },
};
